
<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2>管理系统登录</h2>
      <el-form :model="loginForm" :rules="rules" ref="elFormRef">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
          <el-button @click="showRegister = true">注册</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-dialog title="用户注册" v-model="showRegister">
      <el-form :model="registerForm" :rules="rules" ref="elRegisterForm">
        <el-form-item prop="username">
          <el-input v-model="registerForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" type="password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item prop="role">
          <el-select v-model="registerForm.role" placeholder="请选择角色">
            <el-option label="总经理" value="ADMIN"></el-option>
            <el-option label="经理" value="MANAGER"></el-option>
            <el-option label="主管" value="SUPERVISOR"></el-option>
            <el-option label="用户" value="USER"></el-option>
            <el-option label="会计" value="ACCOUNTANT"></el-option>
            <el-option label="后台人员" value="OTHER"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showRegister = false">取消</el-button>
        <el-button type="primary" @click="handleRegister" :loading="loading">注册</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    const loginForm = ref({
      username: '',
      password: ''
    })

    const registerForm = ref({
      username: '',
      password: '',
      role: 'USER'
    })

    const loading = ref(false)
    const showRegister = ref(false)

    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ],
      role: [
        { required: true, message: '请选择角色', trigger: 'change' }
      ]
    }

    const handleLogin = async () => {
      loading.value = true
      await store.dispatch('login', loginForm.value)
        .then(response => {
          console.log('Login response:'+response)
          if(response && response.code === 1200) {
            router.push('/dashboard')
          }
      }).catch (error =>{
        console.error(error)
      }).finally(() => {
        loading.value = false
      })
    }

    const handleRegister = async () => {
      loading.value = true
      try {
        await store.dispatch('register', registerForm.value)
        showRegister.value = false
        // router.push('/dashboard')
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }

    return {
      loginForm,
      registerForm,
      rules,
      loading,
      showRegister,
      handleLogin,
      handleRegister
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}
.login-card {
  width: 400px;
  padding: 20px;
}
h2 {
  text-align: center;
  margin-bottom: 20px;
}
</style>
